import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
// import ModalModule from '@/store/modules/modal';
import { ModalComponents, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: ModalComponents.Calculator,
  // props: {
  //   placeholderValue: {
  //     required: false,
  //     type: Object as PropType<number>,
  //   },
  // },
  props: {
    visible: {
      required: false,
      type: Object
    },
    placeHolderValue: {
      required: false,
      type: Object
    }
  },
  emits: ["confirmNumber"
  /* this event is declared in the parent component Modal*/
  , "cancelCalculator"],
  setup: function setup(props) {
    // the calculator is now usable as a standalone component and also from Modal component --> Make the calculator used without Modal component
    var dialogVisible = ref(props.visible ? props.visible : dialogVisibleForStatus(ModalStatus.Calculator));
    var inputContent = props.placeHolderValue ? ref(props.placeHolderValue.toString()) : ref("0");
    var decimal = "." || ",";
    var currentCurrency = ref("CHF");
    var el = ref(null);

    function clearInput() {
      inputContent.value = "0";
    }

    function eraseFromInput() {
      // Removes one number
      // if it is the only number then we replace it with 0
      // if it is '0' then we do nothing
      var length = inputContent.value.length;

      if (inputContent.value.length === 1) {
        if (inputContent.value[length - 1] !== "0") {
          var newInput = inputContent.value.replace(inputContent.value[length - 1], "0");
          inputContent.value = newInput;
          return;
        }

        if (inputContent.value[length - 1] === "0") {
          return;
        }
      }

      inputContent.value = inputContent.value.slice(0, length - 1);
    }

    function updateInput(event) {
      var char = event.target.textContent || "";

      if (inputContent.value === "0") {
        inputContent.value = char;
        return;
      }

      inputContent.value = inputContent.value + char;
    }

    function cancel() {
      // Clear the calculator and close it
      clearInput();

      if (ModalModule.status === ModalStatus.Calculator) {
        ModalModule.setStatus(ModalStatus.Hidden);
      } else {
        // this is the case where the calculator is not used inside Modal component, lets emit to cancellation event on parent component
        this.$emit("cancelCalculator");
      }
    }

    return {
      dialogVisible: dialogVisible,
      inputContent: inputContent,
      decimal: decimal,
      currentCurrency: currentCurrency,
      el: el,
      clearInput: clearInput,
      eraseFromInput: eraseFromInput,
      updateInput: updateInput,
      cancel: cancel,
      props: props
    };
  },
  methods: {}
});